import { render, staticRenderFns } from "./OfficeRecord.vue?vue&type=template&id=4f8c2918&scoped=true&"
import script from "./OfficeRecord.vue?vue&type=script&lang=js&"
export * from "./OfficeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c2918",
  null
  
)

export default component.exports